import { render, staticRenderFns } from "./ModalArgEdit.vue?vue&type=template&id=71461d23&scoped=true"
import script from "./ModalArgEdit.vue?vue&type=script&lang=js"
export * from "./ModalArgEdit.vue?vue&type=script&lang=js"
import style0 from "./ModalArgEdit.vue?vue&type=style&index=0&id=71461d23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71461d23",
  null
  
)

export default component.exports